// lib/api/contact.ts
import api from '../api';

export interface ContactPayload {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export async function submitContactForm(payload: ContactPayload) {
  const response = await api.post('/general/contact', payload);
  return response.data;
}